var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "markets-wrapper" }, [
    _vm.market
      ? _c("div", { staticClass: "markets single" }, [
          _c(
            "div",
            {
              class: [
                "market",
                "outright-market",
                { suspended: !_vm.market.istradable },
                "selections-x" + _vm.market.selections.length,
                "col-x" + _vm.colNum,
                {
                  "more-than-three-selections": _vm.market.selections.length > 3
                }
              ],
              attrs: {
                idfomarket: _vm.market.idfomarket,
                isfrompush: (_vm.market.V !== undefined).toString()
              }
            },
            [
              _c("div", { staticClass: "header" }, [
                _c("div", { staticClass: "market-name" }, [
                  _c("h4", { staticClass: "market-name-title text-overflow" }, [
                    _vm._v(_vm._s(_vm.market.name))
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.isDebug
                ? _c("span", { staticClass: "debug" }, [
                    _vm._v("\n        " + _vm._s(_vm.market.idfomarket)),
                    _c("br"),
                    _vm._v(
                      "\n        isfrompush " +
                        _vm._s((_vm.market.V !== undefined).toString()) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "selections-container" }, [
                _c(
                  "div",
                  { staticClass: "selections non-had" },
                  [
                    _vm.market.isoutright
                      ? _vm._l(_vm.outrightSelectionsColumns, function(column) {
                          return _c(
                            "div",
                            { class: ["selection-col", "no" + column] },
                            [
                              _c(
                                "div",
                                { staticClass: "static-selections" },
                                _vm._l(
                                  _vm.market.selections.filter(function(sel) {
                                    return (
                                      sel.selectioncolumn === column &&
                                      sel.displaypage === -1 &&
                                      sel.idfoselectionsuspensiontype !== "N/O"
                                    )
                                  }),
                                  function(selection) {
                                    return _c(
                                      "span",
                                      {
                                        key: selection.idfoselection,
                                        class: [
                                          "selection",
                                          "rotateindex" + selection.displaypage
                                        ]
                                      },
                                      [
                                        _c("selection", {
                                          attrs: {
                                            event: _vm.event,
                                            selection: selection,
                                            istradable: _vm.market.istradable,
                                            showselectionname: true,
                                            ishad: false,
                                            isoutright: true,
                                            fosportname: _vm.event.sportname
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                              _vm._v(" "),
                              (column === 4 || column === 3) &&
                              _vm.scrollableSelections.length > 0
                                ? _c(
                                    "div",
                                    {
                                      ref: "pagedselections",
                                      refInFor: true,
                                      staticClass: "paged-selections"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "pagedselections-clild",
                                          style: { top: _vm.currentScrollTop }
                                        },
                                        _vm._l(
                                          _vm.scrollableSelections,
                                          function(selection) {
                                            return _c(
                                              "span",
                                              {
                                                key: selection.idfoselection,
                                                ref: "selection",
                                                refInFor: true,
                                                class: [
                                                  "selection",
                                                  "rotateindex" +
                                                    selection.displaypage
                                                ]
                                              },
                                              [
                                                _c("selection", {
                                                  attrs: {
                                                    event: _vm.event,
                                                    selection: selection,
                                                    istradable:
                                                      _vm.market.istradable,
                                                    showselectionname: true,
                                                    ishad: false,
                                                    isoutright: true,
                                                    fosportname:
                                                      _vm.event.sportname
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showMoreSelectionsMessage &&
                              column === _vm.numOfOutrightSelectionsColumns
                                ? _c(
                                    "span",
                                    { staticClass: "selection message" },
                                    [
                                      _vm._v(
                                        "\n                See betting booths for more selections\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        })
                      : _vm._e()
                  ],
                  2
                )
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-161db71c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-161db71c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bettingoffer/outrightMarket.vue
// module id = null
// module chunks = 